export const validateOutput = (tags: string[], tag?: string): string[] => {
  const inputTags = tag ? toArrayOfString(tag) : [];
  const newTags = inputTags.filter((t) => !tags.includes(t));
  return newTags.length > 0 ? [...tags, ...newTags] : tags;
};

export const toArrayOfString = (tag: string): string[] => {
  return tag
    .split(/[,;]+/)
    .map((t) => t.trim())
    .filter((t) => t !== "");
};
